import React from 'react';
import { getRandomHeadshot, getHeadshotPath } from './utils';
import { useLanguage } from '../context/LanguageContext';

/**
 * Speaking section component featuring conference speaking services
 */
const SpeakingSection = () => {
  const headshotNumber = getRandomHeadshot();
  const { t } = useLanguage();

  return (
    <section id="speaking" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <h2 className="font-heading text-3xl md:text-5xl font-bold mb-4 text-center">
          {t('speakingTitle')}
        </h2>
        <p className="font-accent text-xl text-gray-600 mb-12 text-center max-w-3xl mx-auto font-light leading-relaxed">
          {t('speakingSubtitle')}
        </p>

        <div className="md:flex md:items-center">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pr-12">
            <img
              src={getHeadshotPath(headshotNumber)}
              alt="Tudor Emanuel Speaking"
              className="rounded-lg shadow-xl w-full object-cover"
            />
          </div>
          <div className="md:w-1/2">
            <h3 className="font-heading text-2xl font-bold mb-4">{t('transformEvent')}</h3>
            <p className="font-accent text-lg text-gray-700 mb-4 leading-relaxed">
              {t('speakingDescription')}
            </p>
            <div className="mb-8">
              <h4 className="font-heading font-bold text-lg mb-2">{t('topicsTitle')}</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2 text-xl">•</span>
                  <span><span className="font-semibold">{t('leadership')}</span> {t('leadershipDesc')}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2 text-xl">•</span>
                  <span><span className="font-semibold">{t('growth')}</span> {t('growthDesc')}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2 text-xl">•</span>
                  <span><span className="font-semibold">{t('excellence')}</span> {t('excellenceDesc')}</span>
                </li>
              </ul>
            </div>
            <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
              <button className="bg-blue-800 hover:bg-blue-900 text-white font-semibold py-3 px-6 rounded-lg transition shadow-md tracking-wide">
                {t('bookEvent')}
              </button>
              <button className="border-2 border-blue-800 text-blue-800 hover:bg-blue-50 font-semibold py-3 px-6 rounded-lg transition tracking-wide">
                {t('viewPortfolio')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakingSection;